import React from "react";
import { Badge, Stack } from "react-bootstrap";

interface HousingStatusState {
  dotClass: string;
  label: string;
  // the people a whole-case assignment covers - a case name alone never says who is inside
  people?: any[];
  alignEnd?: boolean;
}

// Status dot, its label, and the occupant chips underneath. Dwellings, facility rooms and
// standalone rooms all report occupancy the same way, so they render it from here.
const HousingStatus = ({ dotClass, label, people = [], alignEnd = true }: HousingStatusState) => {
  const justify = alignEnd ? "justify-content-end" : "";
  return (
    <div className="assignment-status-wrap order-3 order-xl-1">
      <Stack direction="horizontal" gap={2} className={`align-items-center ${justify}`}>
        <span className={dotClass}></span>
        <span className="small">{label}</span>
      </Stack>
      {people.length > 0 && (
        <Stack direction="horizontal" gap={1} className={`flex-wrap ${justify} mt-1`}>
          {people.map((p: any) => (
            <Badge key={`${p.type}-${p.id}`} bg="none" className="app-primary-color-inverse border fw-normal">
              {p.name}
            </Badge>
          ))}
        </Stack>
      )}
    </div>
  );
};

export default HousingStatus;
